import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import { jwtDecode } from 'jwt-decode';
import { Centered } from '../components';
import { Space, Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [user, setUser] = useState(() => {
        const storedUser = localStorage.getItem('user');

        return storedUser ? JSON.parse(storedUser) : null;
    });
    const [userGroups, setUserGroups] = useState(() => {
        const storedUserGroups = localStorage.getItem('userGroups');

        return storedUserGroups ? JSON.parse(storedUserGroups) : [];
    });
    const navigate = useNavigate();

    /**
     * Verifica se o usuário autenticado
     * pertence a algum dos grupos especificados.
     * 
     * @param {Array} targetGroups
     * @param {String} mode
     * @returns {Boolean}
     */
    const authUserBelongsToGroups = (targetGroups, mode) => {
        if (!targetGroups || !targetGroups.length) {
            return false;
        }

        const userGroupNames = userGroups.flatMap(group => group.name);
        const belongsToUser = groupName => userGroupNames.includes(groupName)

        if (mode === 'strict') {
            return targetGroups.every(belongsToUser)
        }
        
        return targetGroups.some(belongsToUser);
    };

    const login = (accessToken, refreshToken) => {
        const data = jwtDecode(accessToken);

        setUser(data.user);
        setUserGroups(data.user.groups);

        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('userGroups', JSON.stringify(data.user.groups));
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);

        navigate('/reports');
    };

    const logout = () => {        
        setIsLoggingOut(true);
        setUser(null);
        setUserGroups([]);

        localStorage.removeItem('user');
        localStorage.removeItem('userGroups');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');

        window.location.href = `${process.env.REACT_APP_EGIDE_URL}/logout`;
    };
    
    return (
        <AuthContext.Provider
            value={{
                user,
                userGroups,
                setUserGroups,
                login,
                logout,
                authUserBelongsToGroups,
                isLoggingOut
            }}
        >
            {isLoggingOut ? (
                <Centered>
                    <Space direction="vertical" align="center" size="large">
                        <Spin indicator={<LoadingOutlined spin />} size="large" />

                        <Typography.Title level={5}>
                            Sua sessão está sendo encerrada.
                        </Typography.Title>
                    </Space>
                </Centered>
            ) : children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);

    return context;
}
